import { default as BDiaryDaySearchEdiblesFormForm } from "./Profile/BDiaryDaySearchEdibles/Form"
import BChart from "./Modules/BChart"
import BCheckpanel from "../modules/BCheckpanel"
import BDatepicker from "./Modules/BDatepicker"
import BDialogTrigger from "../modules/BDialogTrigger"
import BDiaryDay from "./Profile/BDiaryDay"
import BDiaryDayEntries from "./Profile/BDiaryDayEntries"
import BDiaryDayEntry from "./Profile/BDiaryDayEntry"
import BDiaryDayFormGlucose from "./Profile/BDiaryDayFormGlucose"
import BDrugs from "./Profile/BDrugs"
import BDrugsForm from "./Profile/BDrugsForm"
import BFrontCaloricCalculator from "../Modules/CaloricCalculator/BFrontCaloricCalculator"
import BHealthcareProviderSetupForm from "./Sales/BHealthcareProviderSetupForm"
import BInput from "../Modules/BInput"
import BMeasurements from "./Profile/BMeasurements"
import BMeasurementsForm from "./Profile/BMeasurementsForm"
import BMobileNav from "./Modules/BMobileNav"
import BModalTrigger from "../Modules/BModalTrigger"
import BOAuthAuthorizeForm from "../Modules/BOAuthAuthorizeForm"
import BPrintButton from "./Modules/BPrintButton"
import BProfileArticleFilter from "./Profile/BProfileArticleFilter"
import BProfileArticleReadStatusButtons from "./Profile/BProfileArticleReadStatusButtons"
import BProfileDiaryGlucoseReport from "./Profile/BProfileDiaryGlucoseReport"
import BProfileMessage from "./Profile/BProfileMessage"
import BRecaptchaForm from "../modules/BRecaptchaForm"
import BSalesProductSetupDelegates from "./Sales/BSalesProductSetupDelegates"
import BSalesProductSetupForm from "./Sales/BSalesProductSetupForm"
import BSelect from "./Modules/BSelect"
import BShowtoggle from "../Modules/BShowtoggle"
import BTabs from "../Modules/BTabs"
import BUserIngredientsTable from "./Profile/BUserIngredientsTable"

BChart.initialize();
BCheckpanel.initialize();
BDatepicker.initialize();
BDialogTrigger.initialize();
BDiaryDay.initialize();
BDiaryDayEntries.initialize();
BDiaryDayEntry.initialize();
BDiaryDayFormGlucose.initialize();
BDiaryDaySearchEdiblesFormForm.initialize();
BDiaryNutrientGoalTemplateForm.initialize();
BDrugs.initialize();
BDrugsForm.initialize();
BFrontCaloricCalculator.initialize();
BHealthcareProviderSetupForm.initialize();
BInput.initialize();
BMeasurements.initialize();
BMeasurementsForm.initialize();
BMobileNav.initialize();
BModalTrigger.initialize();
BOAuthAuthorizeForm.initialize();
BPrintButton.initialize();
BProfileArticleFilter.initialize();
BProfileArticleReadStatusButtons.initialize();
BProfileDiaryGlucoseReport.initialize();
BProfileMessage.initialize();
BRecaptchaForm.initialize();
BSalesProductSetupDelegates.initialize();
BSalesProductSetupForm.initialize();
BSelect.initialize();
BShowtoggle.initialize();
BTabs.initialize();
BUserIngredientsTable.initialize();

try {
	document.querySelector(`.focus`).focus();
} catch (error) {
	// Nevermind.
}



// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import BDiaryNutrientGoalTemplateForm from "./Profile/BDiaryNutrientGoalTemplateForm"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDEdeXISMFqaABM2QVNbjSEv-k3Ld__cZI",
  authDomain: "jidelni-plan-17f76.firebaseapp.com",
  projectId: "jidelni-plan-17f76",
  storageBucket: "jidelni-plan-17f76.appspot.com",
  messagingSenderId: "91184796644",
  appId: "1:91184796644:web:4150edfd4600d2070fadf1",
  measurementId: "G-C9WL2FWLG4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
